module.exports = __webpack_public_path__ + "static/img/IMG_20241030_104918.89750a49.jpg";